export const getInitialRenewalStatusIdForNewProject = (allRenewalStatuses) => {
  const newBusiness = allRenewalStatuses.find((status) => status.Name === 'New business');
  return (newBusiness && newBusiness.Id) || null;
};
